module.exports = __webpack_public_path__ + "img/parter-avatar8.f305fe02.png";